import { type SVGProps } from "react";

export const MIRIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    {...props}
  >
    <path
      d="M0 9.07027H2.26885C2.47445 9.07027 3.09367 9.00874 3.36941 9.88332C3.57501 10.4459 3.85076 11.3204 4.26438 12.6323H4.40225C4.81345 11.2567 5.15692 10.3206 5.29479 9.88332C5.57054 9.00874 6.25748 9.07027 6.53323 9.07027H8.66421V15.0692H6.46308V11.5094H6.32521L5.15692 15.0692H3.50729L2.339 11.5094H2.1334V15.0692H0M9.55917 9.07027H11.7603V12.6301H11.9659L13.4099 9.69434C13.6857 9.1318 14.3049 9.07027 14.3049 9.07027H16.3681V15.0692H14.167V11.5094H14.0291L12.5851 14.4451C12.3094 15.0077 11.6224 15.0692 11.6224 15.0692H9.55917M19.3239 13.2563V15.0692H17.2607V11.9445H23.9995C23.7238 12.6938 22.7611 13.2563 21.6605 13.2563"
      fill="#6C7692"
    />
    <path
      d="M23.9474 11.4693C24.2259 10.3895 23.3854 9.06934 21.564 9.06934H16.7998C16.9403 10.3284 18.2022 11.4672 19.5331 11.4672"
      fill="url(#paint0_linear_875_9711)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_875_9711"
        x1="23.1055"
        y1="10.2694"
        x2="17.5"
        y2="10.2694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F5CD7" />
        <stop offset="1" stopColor="#02AEFF" />
      </linearGradient>
    </defs>
  </svg>
);
